import React from 'react';

const BraceletLedLogo = ({ size = 200, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 200 200" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Définitions pour les gradients et effets */}
      <defs>
        {/* Gradient pour le bracelet principal */}
        <linearGradient id="braceletGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8b5cf6" />
          <stop offset="50%" stopColor="#ec4899" />
          <stop offset="100%" stopColor="#f97316" />
        </linearGradient>
        
        {/* Gradient pour les LED lumineuses */}
        <radialGradient id="ledGlow1">
          <stop offset="0%" stopColor="#8b5cf6" stopOpacity="1" />
          <stop offset="70%" stopColor="#8b5cf6" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0" />
        </radialGradient>
        
        <radialGradient id="ledGlow2">
          <stop offset="0%" stopColor="#ec4899" stopOpacity="1" />
          <stop offset="70%" stopColor="#ec4899" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#ec4899" stopOpacity="0" />
        </radialGradient>
        
        <radialGradient id="ledGlow3">
          <stop offset="0%" stopColor="#f97316" stopOpacity="1" />
          <stop offset="70%" stopColor="#f97316" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#f97316" stopOpacity="0" />
        </radialGradient>

        {/* Filtre pour effet de brillance */}
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>

        {/* Animation de pulsation */}
        <animate
          xlinkHref="#led1"
          attributeName="opacity"
          values="1;0.3;1"
          dur="2s"
          repeatCount="indefinite"
        />
        <animate
          xlinkHref="#led2"
          attributeName="opacity"
          values="0.3;1;0.3"
          dur="2s"
          repeatCount="indefinite"
        />
        <animate
          xlinkHref="#led3"
          attributeName="opacity"
          values="1;0.3;1"
          dur="2s"
          repeatCount="indefinite"
        />
      </defs>

      {/* Fond circulaire sombre */}
      <circle cx="100" cy="100" r="95" fill="#0a0a0a" opacity="0.3"/>

      {/* Bracelet principal - forme elliptique */}
      <ellipse 
        cx="100" 
        cy="100" 
        rx="60" 
        ry="70" 
        fill="none" 
        stroke="url(#braceletGradient)" 
        strokeWidth="12"
        filter="url(#glow)"
        opacity="0.9"
      />

      {/* LEDs lumineuses sur le bracelet */}
      {/* LED 1 - Haut */}
      <circle id="led1" cx="100" cy="30" r="8" fill="#8b5cf6" filter="url(#glow)"/>
      <circle cx="100" cy="30" r="15" fill="url(#ledGlow1)" opacity="0.6"/>

      {/* LED 2 - Droite */}
      <circle id="led2" cx="160" cy="100" r="8" fill="#ec4899" filter="url(#glow)"/>
      <circle cx="160" cy="100" r="15" fill="url(#ledGlow2)" opacity="0.6"/>

      {/* LED 3 - Bas */}
      <circle id="led3" cx="100" cy="170" r="8" fill="#f97316" filter="url(#glow)"/>
      <circle cx="100" cy="170" r="15" fill="url(#ledGlow3)" opacity="0.6"/>

      {/* LED 4 - Gauche */}
      <circle cx="40" cy="100" r="8" fill="#8b5cf6" filter="url(#glow)">
        <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite"/>
      </circle>
      <circle cx="40" cy="100" r="15" fill="url(#ledGlow1)" opacity="0.6"/>

      {/* Ondes de contrôle - effet Bluetooth/signal */}
      <g opacity="0.4">
        <path 
          d="M 100 70 Q 120 80 110 100 Q 120 120 100 130" 
          fill="none" 
          stroke="#00d4ff" 
          strokeWidth="2"
          strokeDasharray="5,5"
        >
          <animate attributeName="stroke-dashoffset" from="0" to="20" dur="1s" repeatCount="indefinite"/>
        </path>
        <path 
          d="M 100 70 Q 80 80 90 100 Q 80 120 100 130" 
          fill="none" 
          stroke="#00d4ff" 
          strokeWidth="2"
          strokeDasharray="5,5"
        >
          <animate attributeName="stroke-dashoffset" from="0" to="20" dur="1s" repeatCount="indefinite"/>
        </path>
      </g>

      {/* Icône de contrôle au centre */}
      <g transform="translate(100, 100)">
        {/* Signal/Onde de contrôle */}
        <circle cx="0" cy="0" r="18" fill="#1a1a1a" opacity="0.8"/>
        <path 
          d="M -8 -8 L -8 8 L 0 0 L 8 8 L 8 -8" 
          fill="none" 
          stroke="#00d4ff" 
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="0" cy="0" r="3" fill="#00d4ff"/>
      </g>

      {/* Texte "LED" stylisé */}
      <text 
        x="100" 
        y="195" 
        fontFamily="Arial, sans-serif" 
        fontSize="14" 
        fontWeight="bold" 
        fill="url(#braceletGradient)" 
        textAnchor="middle"
      >
        PARTY LED
      </text>
    </svg>
  );
};

export default BraceletLedLogo;
